import React from 'react';

const SvgUpCarrot = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12 8.4l6.235 6.3H5.765L12 8.4z" />
  </svg>
);

export default SvgUpCarrot;
